<template>
    <div class="info-modal story">
      <div class="info-modal__actions">
        <a-select :value="selectedLanguage" size="small" @change="handleLangChange" class="lang-select">
          <a-select-option v-for="lang in langOptions" :key="lang.value">
            {{ lang.name }}
          </a-select-option>
        </a-select>
      </div>
      <div class="info-modal__content">
        <div v-if="selectedPreview.image" class="info-modal__image-container">
          <img class="info-modal__image"  :src="selectedPreview.image.path" :alt="privilegeInfo.name" />
        </div>
        <div class="info-modal__info-container">
          <div class="info-modal__grid">
            <div class="info-modal__util-width">
              <div class="info-modal__title">Name (for internal usage)</div>
              <span class="mr-2">{{ privilegeInfo.name }}</span>
              <!-- <a-tooltip title="Copy to clipboard" placement="right">
                <a href="javascript:;"><a-icon type="copy" class="font-size-16 text-primary"
                    @click="clipboardHandle('Name', privilegeInfo.name)" /></a>
              </a-tooltip> -->
            </div>
            <div>
              <div class="d-flex align-items-center">
                <div class="info-modal__title mr-2" >Activity period</div>
              </div>
              <div style="position: relative; display: inline-flex; flex-direction: column; gap: 0.2rem;">
                <a-tag class="info-modal--tag">
                  {{ formatDate(privilegeInfo.periods[0].starts_at) }} - {{ formatDate(privilegeInfo.periods[0].ends_at) }}
                </a-tag>
                <template v-if="privilegeInfo.periods.length > 1 && showAllPeriods">
                  <a-tag
                    v-for="(period, idx) in privilegeInfo.periods.slice(1)"
                    :key="idx"
                    class="info-modal--tag"
                  >
                    {{ formatDate(period.starts_at) }} - {{ formatDate(period.ends_at) }}
                  </a-tag>
                </template>
                <a-button
                  v-if="privilegeInfo.periods.length > 1"
                  type="link"
                  style="
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    transform: translateX(100%) translateY(-25%);
                    line-height: 1;
                    height: auto;
                    padding: 0;
                  "
                  @click="() => showAllPeriods = !showAllPeriods"
                >
                  {{ showAllPeriods ? 'Hide' : 'View all' }}
                </a-button>
                <!-- <a-tag v-if="privilegeInfo.periods.length > 1" class="info-modal--tag">+{{privilegeInfo.periods.length - 1}}</a-tag> -->
              </div>
            </div>
            <div>
              <div class="d-flex align-items-center">
                <div class="info-modal__title mr-2" >Title</div>
              </div>
              <div class="mr-2">{{ selectedPreview.title }}</div>
            </div>
            <div v-if="completionDateString">
              <div class="d-flex align-items-center">
                <div class="info-modal__title mr-2" >Сompletion date</div>
              </div>
              <div class="mr-2">{{ completionDateString }}</div>
            </div>
            <div v-if="selectedPreview.button_name">
              <div class="d-flex align-items-center">
                <div class="info-modal__title mr-2" >Button</div>
              </div>
              <div class="mr-2">{{ selectedPreview.button_name }}</div>
            </div>
          </div>
          <!-- <div>
            <div class="info-modal__title">Section</div>
            <div style="line-height: 1.8rem">
              <a-tag class="info-modal--tag"
                v-for="display in privilegeInfo.displays" :key="display.id">
                {{ displays[display.id] }}
              </a-tag>
            </div>
          </div> -->
          <div>
            <div class="info-modal__title">Apps</div>
            <div style="line-height: 2.1rem">
              <a-tag class="info-modal--tag"
                v-for="app in privilegeInfo.applications" :key="app.id">
                {{ app.name }}
                <a-icon v-if="app.platform.toLowerCase() === 'android'" type="android" class="ml-1 text-success" />
                <a-icon v-if="app.platform.toLowerCase() === 'ios'" type="apple" class="ml-1 text-primary" />
                <a-icon v-if="app.platform.toLowerCase() === 'web'" type="global" class="ml-1 text-default" />
              </a-tag>
            </div>
          </div>
        </div>
      </div>
      <a-row>
        <a-col :span="24">
          <div class="d-flex justify-content-between info-modal__footer">
            <a-button @click="clipboardHandle('Privilege', JSON.stringify(privilegeInfo, null, 2) )">
                <a-icon type="copy" class="font-size-14" />
                <span>Copy content</span>
              </a-button>
            <div class="ml-auto text-right">
              <a-button @click="openEditPage">
                <a-icon type="edit" class="font-size-14" />
                <span>Edit</span>
              </a-button>
              <a-button type="primary" style="margin-left: 10px;" @click="closeModal">
                OK
              </a-button>
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
  </template>

<script>
import dayjs from 'dayjs'
// import utc from 'dayjs/plugin/utc'
// import timezone from 'dayjs/plugin/timezone'
import 'dayjs/locale/ru'

export default {
  name: 'privilegeInfoModal',
  props: {
    privilegeInfo: {
      type: Object,
    },
    languages: {
      type: Array,
    },
  },
  computed: {
    langOptions() {
      const langIds = this.privilegeInfo.localizations.map(l => l.lid)
      return this.languages.filter(language => langIds.includes(language.id)).map(language => ({
        name: language.desc,
        value: language.name,
      }))
    },
    selectedLanguageId() {
      return this.languages.find(l => l.name === this.selectedLanguage)?.id
    },
    selectedPreview() {
      return this.privilegeInfo.localizations.find(l => l.lid === this.selectedLanguageId)
    },
    completionDateString() {
      const isoDate = this.selectedPreview.completion_at

      if (!isoDate) {
        return null
      }

      const date = dayjs.utc(isoDate).tz('Europe/Moscow')
      const hour = date.hour()
      const minute = date.minute()

      if ((hour === 0 || hour === 3) && minute === 0) {
        return `до ${date.format('D MMMM')}`
      } else {
        return `до ${date.format('D MMMM')} в ${date.format('HH:mm')}`
      }
    },
  },
  data: () => ({
    selectedLanguage: 'ru',
    showAllPeriods: false,
    displays: {
      1: 'Live',
      3: 'Promo',
      4: 'Main',
    },
  }),
  created() {
  },
  methods: {
    formatDate: function (date) {
      return this.$moment(date).format('DD.MM.YY HH:mm')
    },
    handleLangChange(selectedLangKey) {
      this.selectedLanguage = selectedLangKey
    },
    openEditPage() {
      // if (!this.sectionId) {
      //   return this.$router.push(`/popup-banners/edit/${this.privilegeInfo.id}`)
      // }
      this.$router.push(`/privileges/edit/${this.privilegeInfo.uuid}`)
    },
    closeModal() {
      this.$emit('close')
    },
    clipboardHandle(text, info) {
      this.$clipboard(info)
      this.$notification.success({
        message: `${text} successfully copied to clipboard`,
        description: info.slice(0, 50) + '...',
      })
    },
    copyPopupInfo() {
      this.$clipboard(JSON.stringify(this.privilegeInfo, null, 2))
    },
  },
}
</script>

<style lang="scss" src="./style.module.scss" />
